import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Components
import SingleInput from "../../components/UI/SingleInput";
import IconButton from "../../components/UI/IconButton";
import Header from "../../components/fleetReserve/fleetreservation/Header";
import HistorySubHeader from "../../components/fleetReserve/fleetreservation/HistorySubHeader";
import MapContentView from "../../components/layouts/MapContentView/MapContentView";
import EditReservationProfile from "../../components/modals/EditReservationProfile";

// Services and Utilities
import { getStorage } from "../../services/localStorageService";
import { ShowNotification } from "../../services/Notifications";
import ServiceCenterRequest from "../../services/ServiceCenterRequest";
import TaskManagerRequest from "../../services/TaskManagerRequest";
import { getImageURL } from "../../configs/common";

// Redux Actions
import { toggleSidebar } from "../../store/actions/group.action";
import { fetchReservations } from "../../store/actions/fleetReserve.action";
import moment from "moment";
import EditReservationModal from "../../components/modals/fleet-reserve/EditReservationModal";
import EditUserReservationModal from "../../components/modals/fleet-reserve/EditUserReservationModal";
import _ from "underscore";
import { matchWithField } from "../../components/fleetReserve/PickDropsCard";
import { getTaskSettings } from "../../store/actions/setting.action";
import Loader from "../../components/UI/Loader";
const FleetReservationHistory = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const fleetReservation = getStorage("__fleetReservation__", "object");
  const rides = useSelector((state) => state.fleetReserveReducer.rides);
  const [currentEditTask, setCurrentEditTask] = useState(null);
  const toggleEditTaskModal = (task) => {
    setCurrentEditTask(task);
    setEditTask(!editTask);
  };

  // State Management
  const [isLoading, setLoading] = useState(true);
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [interval, setInterval] = useState("Current Month");
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  );
  const [editTask, setEditTask] = useState(false);
  const [endDate, setEndDate] = useState(
    new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0,
      23,
      59,
      59,
      999,
    ),
  );
  console.log(rides);
  
  const _taskSettings = useSelector(
    (state) => state.settingReducer.taskSettings,
  );
   const _driverGroups = useSelector(
    (state) => state.taskReducer.taskDriverGroups,
  );
  const taskHeaderSwitchOn = useSelector(
    (state) => state.taskReducer.taskHeaderSwitchOn,
  );
 
  const [taskFieldsSettings, setTaskFieldsSetting] = useState(_taskSettings);
  const [reservations, setReservations] = useState([]);
  const taskDrivers = useSelector((state) => state.taskReducer.taskDrivers);
  const toggleEditProfileModal = () => setEditProfileModal(!editProfileModal);
  const time = useSelector((state) => state.fleetReserveReducer.time);
  const [searchText, setSearchText] = useState("");
  const [reservation, setReservation] = useState([]);
  const [reservationResponse, setReservationResponse] = useState([]);
    const taskFields =[
  {
    "order": 1,
    "type": "text",
    "label": "Job Description",
    "key": "description"
  },
  
  {
    "order": 3,
    "type": "text",
    "label": "Name",
    "key": "name"
  },
  {
    "order": 4,
    "type": "populate",
    "label": "Driver",
    "key": "driver"
  },
  
  
  {
    "order": 7,
    "type": "text",
    "label": "From Time",
    "key": "fromTime"
  },
  
 
  
  
  {
    "order": 12,
    "type": "text",
    "label": "Reservation Type",
    "key": "reserveType"
  }
]

  const loadExpenses = async (data = {}, isLoadMore = false) => {
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD 00:00:00");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD 23:59:59");

    const requestData = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      createdByRole: fleetReservation.username,
    };

    console.log(requestData);

    try {
      await dispatch(fetchReservations(requestData));

    
    } catch (error) {
      ShowNotification("error", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteTaskHandler = async (id) => {
    var __data = { task: id };
    console.log("__data", __data);
    if (!window.confirm("Are you sure you want to delete this tasks?")) return;
   
  const formattedStartDate = moment(startDate).format("YYYY-MM-DD 00:00:00");
     const formattedEndDate = moment(endDate).format("YYYY-MM-DD 23:59:59");
     
     const _d = {
       startDate: formattedStartDate,
       endDate:formattedEndDate,
       createdByRole: fleetReservation.username,
     };
    //  if (!assignmentStatus) {
    //    if (taskGroups.length > 0) {
    //      await dispatch(SetActiveDriver(taskGroups[0].Drivers[0]._id));
    //    }
    //  }
    try {
      const response = await TaskManagerRequest(
        `/fleet/delete/reservation`,
        __data,
      );
      //  await dispatch(AssignmentStatus(true));

      await dispatch(fetchReservations(_d));
      ShowNotification("success", "Reservation deleted successfully");
    
    } catch (error) {
      ShowNotification("error", error);
    }
  };

  // Status badge color mapper


  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  
  const filterTask = () => {
      var cloneTask = rides?rides:[];
      var filterdTasks = [];
 
  
    
  
      if (searchText != "") {
        cloneTask.map((t) => {
          // check uniqueId match
          if (
            t.uniqueId &&
            String(t.uniqueId).match(new RegExp(searchText, "gi"))
          ) {
            filterdTasks.push(t);
            return false;
          }
          taskFields.map((taskField) => {
            const field = matchWithField(taskField);
            try {
              if (
                t[field.key] &&
                t[field.key] !== "populate" &&
                String(t[field.key]).match(new RegExp(searchText, "gi"))
              ) {
                filterdTasks.push(t);
                return false;
              }
  
              // Customer Fields
  
              if (
                t.customer &&
                t.customer.name.match(
                  new RegExp(searchText, "gi") ||
                    t.customer.phoneNumber.match(new RegExp(searchText, "gi"))
                )
              ) {
                filterdTasks.push(t);
                return false;
              }
  
              // Attributes
              if (
                t.attributes &&
                t.attributes[field.key] &&
                t.attributes[field.key].match(new RegExp(searchText, "gi"))
              ) {
                filterdTasks.push(t);
                return false;
              }
            } catch (error) {
              console.log("Error", error);
            }
          });
  
          // if ((t.description && t.description.match(new RegExp(searchText, 'gi')))
          //     || (t.customer && t.customer.name.match(new RegExp(searchText, 'gi')))
          //     || (t.customer && t.customer.address.match(new RegExp(searchText, 'gi')))) {
  
          //     filterdTasks.push(t)
          // }
        });
      } else {
        filterdTasks = cloneTask;
        
      }

  
      return _.uniq(filterdTasks, function (x) {
        return x._id;
      });
    };
    
      const loadSettings = async () => {
        dispatch(getTaskSettings());
        console.log("Current rides", rides);
      };
 useEffect(() => {
    loadSettings();
  
  }, []);
  useEffect(() => {
    if (!_taskSettings) return;
    setTaskFieldsSetting(_taskSettings);
  }, [_taskSettings]);
useEffect(() => {
    setReservation(filterTask());
  }, [rides, searchText]);


  useEffect(() => {
    loadExpenses();
  }, [startDate, endDate]);

  return (
    <>
      <EditUserReservationModal
        startDate={startDate}
        endDate={endDate}
        show={editTask}
        task={currentEditTask}
        toggleModal={() => toggleEditTaskModal(null)}
      />

      <div className="as-main-container">
        <div className="as-header shadow-sm">
          <Header />
        </div>

        <div className="as-body-conten as-body-content-no-sidebar">
          <div className="as-body-data w-100">
            <div className="bg-light border-bottom">
              <HistorySubHeader
                setInterval={setInterval}
                interval={interval}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDate={startDate}
                endDate={endDate}
                searchText={searchText}
                setSearchText={setSearchText}
              />
            </div>

            <div className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="mb-0">Fleet Reservation History</h6>
                {isLoading && (
                  <Loader style={{ top: 500, left: "45%" }} />
                )}
              </div>

              <div className="card border-0 shadow-sm">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr className="bg-light">
                          <th className="py-3">#</th>
                          <th className="py-3">Name</th>
                          <th className="py-3">Driver Name</th>
                          <th className="py-3">Date</th>
                          <th className="py-3">Time Slot</th>
                          <th className="py-3">Duration</th>
                          <th className="py-3">Description</th>
                          <th className="py-3">Status</th>
                          <th className="py-3">Created At</th>
                          <th className="py-3">Reservation Status</th>
                          <th className="py-3">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservation && reservation.length > 0 ? (
                          reservation.map((res, index) => (
                            <tr key={res._id} className="align-middle">
                              <td>{index + 1}</td>
                              <td className="fw-medium">{res.name}</td>
                              <td>
                                {res.driver ? (
                                  <span className="fw-medium">
                                    {res.driver.name}
                                  </span>
                                ) : (
                                  <span className="text-muted fst-italic">
                                    Not Assigned
                                  </span>
                                )}
                              </td>

                              <td>{new Date(res.date).toLocaleDateString()}</td>

                              <td>
                                <span className="text-nowrap">
                                  {res.fromTime} - {res.toTime}
                                </span>
                              </td>
                              <td>{res.duration}</td>
                              <td>
                                <div
                                  style={{ maxWidth: "200px" }}
                                  className="text-truncate"
                                >
                                  {res.description || "N/A"}
                                </div>
                              </td>
                              <td>
                                <span
                                >
                                  {res.status || "No Status Given"}
                                </span>
                              </td>

                              <td>{formatDate(res.createdAt)}</td>
                              <td>
                                <span
                                >
                                  {res.reserveType || "Reservation Pending"}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex ">
                                  <div
                                    className="edit-container pointer mr-1 mt-0"
                                    onClick={() => toggleEditTaskModal(res)}
                                  ></div>
                                  <div
                                    className="delete-container pointer mr-1"
                                    onClick={() => deleteTaskHandler(res._id)}
                                  ></div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-5">
                              <div className="d-flex flex-column align-items-center">
                                <i
                                  className="fas fa-calendar-times text-muted mb-3"
                                  style={{ fontSize: "2rem" }}
                                ></i>
                                <p className="mb-0 text-muted">
                                  No reservation history found for this period.
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {editProfileModal && (
                <EditReservationProfile
                  show={editProfileModal}
                  onHide={toggleEditProfileModal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FleetReservationHistory;
